import React, { useState } from "react";
import { Grid } from "@mui/material";

import UserLogin from "./components/UserGrids";
import ComponyLogin from "./components/ComponyGrids";
import { useAppSelector } from "../../../hooks/useRedux";

export default function LoginPage() {
  const loginType = useAppSelector((state) => state.setting.loginGrids);
  return loginType === "user" ? <UserLogin /> : <ComponyLogin />;
}
